import { DoubleRightOutlined } from '@ant-design/icons';
import { Space } from 'antd';

import styles from './Header.module.scss';

const Header = props => {
    const { title, showExpandAll, onExpandToggle, isExpanded } = props;

    return (
        <div className={styles.container}>
            <span>{title}</span>
            <Space className={styles.actions}>
                {props.children}
                {showExpandAll && (
                    <div onClick={onExpandToggle} className={styles.expandAllIcon}>
                        <DoubleRightOutlined rotate={isExpanded ? 270 : 90} />
                    </div>
                )}
            </Space>
        </div>
    );
};

export default Header;
